import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { gsap } from 'gsap';
import Link from '../common/customlink';

const HeroWrapper = styled.div`
    max-width: 100%;
`;


const HeroText = styled.h2`
    font-family: 'Work Sans';
    font-size: 150px;
    line-height: 135px;
    letter-spacing: 2px;
    font-weight: 700;
    opacity: ${props => props.appear && '0'};
    @media (max-width: 1600px) {
        font-size: 130px;
        line-height: 117px;
    }
    @media (max-width: 1200px) {
        font-size: 92px;
        line-height: 80px;
    }
    @media (max-width: 600px) {
        font-size: 50px;
        line-height: 54px;
    }
`;

const HeroParagraph = styled.h3`
    max-width: 780px;
    margin-top: 30px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 38px;
    color: #0E0E0E;

    @media (max-width: 1200px) {
        font-size: 24px;
        line-height: 29px;
        max-width: 628px;
    }
`;


const HomeHero = ({
    heroText = 'Innovation. Experience. Trust',
    webGlLoaded = false,
    langKey = 'en',
    paragraph
}) => {
    const paragraphRef = React.createRef();

    const [ initialized, setInitialized ] = useState(false);


    function fadeIn() {
        console.log('fade in');
        gsap.to(paragraphRef.current, 0.2, {
            y: 0,
            opacity: 1,
        });
    }

    useEffect(() => {
        if ( initialized ) {
            fadeIn();
        } 
    }, [ initialized ]);

    useEffect(() => {
        const fadeInFunc = fadeIn.bind(this);
        gsap.fromTo(paragraphRef.current, 0.6, {
            y: 100,
            opacity: 0,
        }, {
            y: 0,
            opacity: 1,
            onComplete: () => setInitialized(true),
        });

        window.addEventListener('end-transition', fadeInFunc);
        return () => window.removeEventListener('end-transition', fadeInFunc);
    }, []);

    return (
        <HeroWrapper>
            {
                heroText.split(' ').map((element, index) => (
                    <HeroText
                        key={`hero-text-${element}`}
                        appear={webGlLoaded}
                    >
                        {element}
                    </HeroText>
                ))
            }
            <HeroParagraph ref={paragraphRef}>
                {paragraph}
            </HeroParagraph>
        </HeroWrapper>
    );
}

export default HomeHero;
